import React from 'react';
import AppConfigDisplay from '../components/AppConfigDisplay';

const TestConfig = () => {
  return (
    <div className="container mt-4">
      <h1>Multi-Tenant Configuration Test</h1>
      <p>
        This page displays the configuration for the current app.
        You can use it to verify that the multi-tenant setup is working correctly.
      </p>
      <AppConfigDisplay />
    </div>
  );
};

export default TestConfig; 